import { useUserEvents } from '../store/user-events.store';
import { isMobileViewport } from './isMobile';

const platform = () => (isMobileViewport() ? 'mobile' : 'desktop');

/**
 * Tracking is best effort: `trackEvent` rethrows an API failure after logging it, and a lost analytics row
 * must never surface in the queue action that fired it.
 */
const send = (name, properties) => {
	useUserEvents().trackEvent(name, properties).catch(() => {});
};

/**
 * Record an AutoApply Queue event about one application: its job, uuid and the queue status it had at the
 * action. Call it once the action has succeeded.
 *
 * @param {string} name - One of `AUTOAPPLY_QUEUE_EVENTS`
 * @param {{ uuid: string, status: string, job: { id: number } }} application
 * @param {Object} [properties] - Event specific properties, merged after the shared ones
 */
export const trackQueueApplicationEvent = (name, application, properties = {}) => {
	send(name, {
		job_board_job_id: application.job.id,
		application_uuid: application.uuid,
		status: application.status,
		platform: platform(),
		...properties,
	});
};

/**
 * Record an AutoApply Queue event that is not about one application, such as a toggle or a tutorial step.
 *
 * @param {string} name - One of `AUTOAPPLY_QUEUE_EVENTS`
 * @param {Object} [properties] - Event specific properties, merged after `platform`
 */
export const trackQueueEvent = (name, properties = {}) => {
	send(name, { platform: platform(), ...properties });
};
